const {
  PUBLIC_URL,
  REACT_APP_TOKEN_COOKIE_DOMAIN,
  REACT_APP_TOKEN_COOKIE_EXPIRY,
  REACT_APP_IV_URL,
  REACT_APP_IV_APPS_URL,
  REACT_APP_API_URL,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_ENV_STATIC_S3_URL,
  REACT_APP_PUBLIC_POSTHOG_HOST,
  REACT_APP_PUBLIC_POSTHOG_KEY,
  REACT_APP_POSTHOG_ENABLED,
} = process.env;

const PASSWORD_RESET_EMAIL_PATH = "password_reset_email";
const RESET_PASSWORD_PATH = "reset_password";
const LOGIN_PATH = "login";
const COOKIE_TOKEN = "token";
const SESSION_STORAGE_SIDE_NAV_EXPANDED = "cig_side_nav_expanded";
const SESSION_STORAGE_SIDE_NAV_SELECTED_ITEM = "cig_side_nav_selected_item";
const HELP_SITE_URL = "https://kb.intelligentview.ca/";
const SESSION_STORAGE_SIDE_NAV_SECTION = "cig_side_nav_expanded";
const SESSION_STORAGE_SIDE_NAV_ITEM = "cig_side_nav_selected_item";
const REACT_APP_ENV = process.env.REACT_APP_ENV || "development";

export {
  PUBLIC_URL,
  REACT_APP_TOKEN_COOKIE_DOMAIN,
  REACT_APP_TOKEN_COOKIE_EXPIRY,
  REACT_APP_IV_URL,
  REACT_APP_IV_APPS_URL,
  REACT_APP_API_URL,
  REACT_APP_ENV,
  REACT_APP_ENV_STATIC_S3_URL,
  REACT_APP_PUBLIC_POSTHOG_HOST,
  REACT_APP_PUBLIC_POSTHOG_KEY,
  PASSWORD_RESET_EMAIL_PATH,
  RESET_PASSWORD_PATH,
  LOGIN_PATH,
  COOKIE_TOKEN,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  SESSION_STORAGE_SIDE_NAV_EXPANDED,
  SESSION_STORAGE_SIDE_NAV_SELECTED_ITEM,
  HELP_SITE_URL,
  SESSION_STORAGE_SIDE_NAV_SECTION,
  SESSION_STORAGE_SIDE_NAV_ITEM,
  REACT_APP_POSTHOG_ENABLED,
};
